import { createBrowserRouter } from "react-router-dom";

import routes from "./routes";
import { BASENAME } from './constants';
import { GetWindowLanguage } from "../helpers/storyHelpers";

const buildBasename = () => {
  const langBase = GetWindowLanguage();
  if (langBase === 'en') return BASENAME;
  return `${langBase}/${BASENAME}`
}

const getRouter = () => createBrowserRouter(routes, {
  basename: `/${buildBasename()}`
});

export default getRouter;
